import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { Translations } from '../models/translations.model';

type DataAccessRegionalizationTranslationsState = {
  translations: Translations;
  loadingTranslations: boolean;
  loadTranslationsError: string | null;
};

const initialState: DataAccessRegionalizationTranslationsState = {
  translations: {},
  loadingTranslations: false,
  loadTranslationsError: null,
};

export const DataAccessRegionalizationTranslationsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => {
    const setLoadingTranslations = (loading: boolean) => {
      patchState(store, {
        loadingTranslations: loading,
      });
    };

    const setLoadTranslationsError = (error: string | null) => {
      patchState(store, {
        loadTranslationsError: error,
      });
    };

    const reset = () => {
      patchState(store, {
        ...initialState,
      });
    };

    return {
      setLoadingTranslations,
      setLoadTranslationsError,
      reset,
    };
  })
);
